<script setup>
import { useMSAuth } from '@/auth/msAuth'
import { LogOutOutline } from '@vicons/ionicons5'

const auth = useMSAuth()
const user = auth.getUser()
</script>

<template>
  <div>
    <span>{{ user.name || 'Welcome' }} </span>
    <n-button
      v-if="user.isLoggedIn"
      @click="auth.logout()"
      strong
      secondary
      round
      size="small"
      type="error"
      icon-placement="right"
    >
      <template #icon>
        <LogOutOutline />
      </template>
      Logout
    </n-button>
  </div>
</template>

<style scoped>
div {
  display: flex;
  height: 50px;
  align-items: center;
  justify-content: flex-end;
  margin-left: 1rem;
}

span {
  font-weight: 500;
  font-size: 1rem;
  padding-right: 16px;
}
</style>
